export default "__VITE_ASSET__B12o8oVF__"